/**
 * Returns the count of consecutive weekly score increases (strict >) at the
 * END of the sparkline. Returns 0 when no streak.
 */
export function computeStreak(points) {
  if (!points || points.length < 2) return 0;
  let streak = 0;
  for (let i = points.length - 1; i > 0; i--) {
    if (points[i].score > points[i - 1].score) streak++;
    else break;
  }
  return streak;
}
